<template>
    <div>
        <v-data-table
            dense
            v-model="selected"
            :items="data"
            :options.sync="options"
            :loading="loading"
            :server-items-length="length"
            show-select
            single-select
            @item-selected="setSelectedFromCheckbox"
            @click:row="setSelected"
            @dblclick:row="openInvoiceDisplayDialog"
            @contextmenu:row="openContextMenu"
            :footer-props="{ 'items-per-page-options': [5,10,15] }"
            :headers="headers"
            :disable-pagination="!pagination"
            :hide-default-footer="!pagination">
            <template v-slot:[`item.due_amount`]="{ item }">
                {{ formatMoney(item.due_amount, currency, decimal) }}
            </template>
            <template v-slot:[`item.state`]="{ item }">
                <p-status :state="item.state"></p-status>
            </template>
        </v-data-table>
        <ContextMenu
            v-if="contextMenu.display"
            :position="contextMenu.position"
            :items="contextMenuItems"
            @contextmenu:click="contextMenuClicked"/>
        <InvoiceDisplayDialog
            ref="invoiceDisplayDialog"
            v-on="$listeners"/>
        <InvoiceDialog
            v-if="invoiceDialog.display"
            :display="invoiceDialog.display"
            :id="getSelected.id"
            @close="invoiceDialog.display = false"
            @submit="$emit('updated')"
            />
        <DeleteSingleDialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
    </div>
</template>

<script>
import {formatMoney} from 'accounting';
import {mapActions, mapState} from 'vuex';
import ContextMenu from '../common/ContextMenu';
import InvoiceDisplayDialog from '../Sales/InvoiceDisplayDialog';
import InvoiceDialog from '../Sales/InvoiceDialog';
import DeleteSingleDialog from '../common/DeleteSingleDialog';
import getColor from '@/utils/getColor';
import PStatus from '../common/PStatus.vue';
export default {
    name: "InvoicesDataTable",
    components: {
        ContextMenu,
        InvoiceDisplayDialog,
        InvoiceDialog,
        DeleteSingleDialog,
        PStatus
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        customerId: {
            type: Number,
            required: false
        },
        length: {
            type: Number,
            required: false
        },
        loading: {
            type: Boolean,
            required: true
        },
        pagination: {
            type: Boolean,
            required: true
        },
        options: Object
    },
    data() {
        return {
            currency: "SDG ",
            decimal: 2,
            selected: [],
            headers: [
                { text: this.$t('code'), value: "code" },
                { text: this.$t('date'), value: "date"  },
                { text: this.$t('due_date'), value: "due_date"  },
                { text: this.$t('customer'), sortable: false, value: "customer" },
                { text: this.$t('due_amount'), sortable: false, value: "due_amount" },
                { text: this.$t('state'), value: 'state' }
            ],
            contextMenu: {
                display: false,
                position: {
                    x: 0,
                    y: 0,
                }
            },
            invoiceDialog: {
                display: false
            }
        }
    },
    watch: {
        options: {
            handler() {
                this.$emit("update:options", this.options);
            }
        }
    },
    computed: {
        ...mapState('authentication', ["authorizations"]),
        contextMenuItems() {
            return [
                { title: this.$t("show"), icon: "mdi-eye", action: "openInvoiceDisplayDialog", disabled: !this.authorizations.invoices.read},
                { title: this.$t("edit"), icon: "mdi-pencil", action: "openInvoiceEditDialog", disabled: !this.isEditable},
                { title: this.$t("delete"), icon: "mdi-delete", action: "openInvoiceDeleteDialog", disabled: !this.isDeletable}
            ]
        },
        isDeletable() {
            if(!this.getSelected.meta) return false;
            else return this.getSelected.meta.deletable && this.authorizations.invoices.delete;
        },
        isEditable() {
            if(!this.getSelected.meta) return false;
            else return this.getSelected.meta.editable && this.authorizations.invoices.update;
        },
        getSelected() {
            return this.selected.length == 1 ? this.selected[0] : {};
        }
    },
    methods: {
        ...mapActions("sales/invoice", ["removeInvoice"]),
        formatMoney,
        getColor,
        pushSelected(invoice) {
            this.selected.push(invoice);
            this.$emit("selected:row", invoice);
        },
        clearSelected() {
            this.selected = [];
        },
        setSelected(invoice) {
            this.clearSelected();
            this.pushSelected(invoice);
        },
        setSelectedFromCheckbox({value, item}) {
            if(value) this.setSelected(item);
            else this.$emit("selected:clear");
        },
        openInvoiceDisplayDialog() {
            this.$refs.invoiceDisplayDialog.open({id: this.getSelected.id});
        },
        openInvoiceEditDialog() {
            this.invoiceDialog.display = true;
        },
        openInvoiceDeleteDialog() {
            this.$refs.deleteSingleDialog.open({target: "invoice", id: this.getSelected.id});
        },
        openContextMenu(e, payload) {
            e.preventDefault();
            this.contextMenu.position.x = e.clientX
            this.contextMenu.position.y = e.clientY
            this.contextMenu.display = false;
            this.$nextTick(() => {
                this.contextMenu.display = true;
            });
            this.setSelected(payload.item);
        },
        contextMenuClicked(action) {
            this[action]();
        },
        // getColor(state) {
        //     if(state.toUpperCase() == 'UNPAID') return 'error';
        //     if(state.toUpperCase() == 'OVERDUE') return 'orange lighten-3';
        //     else return 'warning';
        // },
        onDeleteDialogSubmit(params) {
            if(params.target == 'invoice') {
                this.removeInvoice(params)
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.clearSelected();
                        this.$emit("updated");
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
    }
}
</script>